import type { FC } from 'react';
import type { ImageProps } from '@theme-ui/components';
import { Image } from '@theme-ui/components';

import checkMarkGreen from './checkMarkGreen.svg';
import exclamationMarkBlue from './exclamationMarkBlue.svg';
import exclamationMarkYellow from './exclamationMarkYellow.svg';

const icons = {
  'exclamation-mark-blue': exclamationMarkBlue,
  'exclamation-mark-yellow': exclamationMarkYellow,
  'check-mark-green': checkMarkGreen,
};

interface IconProps extends ImageProps {
  type: keyof typeof icons;
  [key: string]: unknown;
}

const Icon: FC<IconProps> = ({ type, ...props }) => {
  return <Image {...props} src={icons[type]} />;
};

export default Icon;
